import React from 'react';
import { motion } from 'framer-motion';
const modules = [{
  num: 1,
  title: 'Fundamentos',
  desc: 'Dónde empezar, nichos, legalidad básica y viabilidad.'
}, {
  num: 2,
  title: 'Menús prácticos',
  desc: 'Recetas con paso a paso detallado.'
}, {
  num: 3,
  title: 'Costeo básico',
  desc: 'Precio simple con fórmulas fáciles de aplicar.'
}, {
  num: 4,
  title: 'Producción en casa',
  desc: 'Organización y tiempos realistas para cocinar.'
}, {
  num: 5,
  title: 'Empaque y conservación',
  desc: 'Técnicas para consumo propio o venta local.'
}, {
  num: 6,
  title: 'Vender sin drama',
  desc: 'Mensajes, WhatsApp y redes para empezar a ofrecer.'
}, {
  num: 7,
  title: 'Cómo crecer',
  desc: 'Paso a paso si querés escalar tu emprendimiento.'
}, {
  num: 8,
  title: 'Plantillas y recursos',
  desc: 'Ejemplos y checklist para lanzar rápido.'
}];
export const ModulesSection: React.FC = () => {
  return <section className="py-24 px-4 md:px-8 bg-brand-bg" data-id="element-87">
      <div className="max-w-5xl mx-auto" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-89">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-primary mb-4" data-id="element-90">
            ¿Qué incluye COCINA VIANDERA?
          </h2>
          <p className="text-xl text-brand-text-medium font-medium" data-id="element-91">
            Tu guía completa paso a paso
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-92">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-brand-cream flex items-start space-x-4" data-id="element-93">
              <div className="flex-shrink-0 w-12 h-12 bg-brand-soft rounded-full flex items-center justify-center text-white font-bold text-xl font-serif" data-id="element-94">
                {mod.num}
              </div>
              <div data-id="element-95">
                <h3 className="text-lg font-bold text-brand-primary mb-1" data-id="element-96">
                  Módulo {mod.num} — {mod.title}
                </h3>
                <p className="text-brand-text-medium" data-id="element-97">{mod.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};